import { Pipe, PipeTransform } from '@angular/core';

import { atividadeTipos } from '../atividade-tipo';

@Pipe({
    name: 'atividadeTipo'
})
export class AtividadeTipoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = atividadeTipos.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return atividadeTipos[index].nome;
        }
        return '';
    }
}
